import script from "./ManagerDevicesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManagerDevicesView.vue?vue&type=script&setup=true&lang=ts"

import "./ManagerDevicesView.vue?vue&type=style&index=0&id=bea65dc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bea65dc6"]])

export default __exports__